<!--
 * @message: 悬浮固定
 * @Author: cjc
 * @since: 2019-11-27 16:23:53
 * @lastTime     : 2020-01-06 11:10:13
 * @LastAuthor   : cjc
 -->
<template>
  <div id="floating-box">
    <div class="wrapper">
      <button id="toggleFold" @click="handlerToggle" class="btn fold"></button>
      <div class="order-box">
        <div class="imgCont">
          <img src="@/assets/images/icon.png" alt />
        </div>
        <a :href="href" class="btn google" @click="fbTrack"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'floating-box',
  data () {
    return {
      href: 'https://play.google.com/store/apps/details?id=com.leyou.gongting.yanxi',
      status: false
    }
  },
  methods: {
    handlerToggle () {
      this.status = !this.status
      let wrapper = document.getElementById('floating-box')
      let toggleFold = document.getElementById('toggleFold')
      wrapper.classList = this.status ? 'order-box folding' : 'order-box unfolding'
      toggleFold.classList = this.status ? 'btn unfold' : 'btn fold'
      this.status ? setTimeout(() => {
        wrapper.getElementsByClassName('order-box')[0].style.display = 'none'
      }, 980) : wrapper.getElementsByClassName('order-box')[0].style.display = ''
    },
    fbTrack () {
      // eslint-disable-next-line no-undef
      fbq('track', 'AddToCart')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixins.scss";
@import "@/assets/styles/variable.scss";

@keyframes folding {
  from {
    right: 0;
  }
  to {
    right: -8.7vw; // 使用vw自适应
  }
}

@keyframes unfolding {
  from {
    right: -8.385vw;
  }
  to {
    right: 0;
  }
}

#floating-box {
  @include fixed-middle(0, right);
  @include setIndex($fixed-layer);
  @include flex(space-between, flex-end, column);
  .wrapper {
    .order-box {
      @include inline-flex(center, center, column);
      @include size(161px, 284px);
      @include setBg("../assets/images/sidebar.png");
      vertical-align: middle;
      .imgCont {
        @include size(121px, 121px);
      }
      .google {
        margin-top: 10px;
      }
    }
    button {
      vertical-align: middle;
    }
  }
}
#floating-box {
  &.folding {
    animation: folding 1s;
  }
  &.unfolding {
    animation: unfolding 1s;
    .order-box {
      display: inline-flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/floatingBox.vue